"use client";

import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
const wp_query_params = {
  per_page: 8,
  orderby: "popularity"
};
const wp_query = new WP_Query(wp_query_params);
function ProductsCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="flex gap-4 overflow-hidden">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4 shrink-0">
            <div className="aspect-[4/5] bg-muted animate-pulse rounded-md mb-4" />
            <div className="h-6 bg-muted animate-pulse w-3/4 mx-auto mb-2" />
            <div className="h-4 bg-muted animate-pulse w-1/4 mx-auto" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive py-8 font-default">
        Error loading our sustainable collection.
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="text-center text-muted-foreground py-8 font-default">
        Our eco-friendly stock is currently being replenished.
      </div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent className="-ml-4">
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="pl-4 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
            <div className="group relative flex flex-col h-full bg-card border border-border shadow-sm transition-all duration-300 hover:shadow-md">
              <div className="relative overflow-hidden aspect-[4/5] bg-muted">
                <Link to={product.link} className="block w-full h-full">
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-secondary text-secondary-foreground">
                      <span className="font-mono text-xs uppercase tracking-widest">No Image</span>
                    </div>}
                </Link>
                <div className="absolute bottom-4 right-4 z-10 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground shadow-md hover:bg-primary/90 px-5 py-2 rounded-md text-sm font-bold font-default" text="Quick Add" showQuantity={false} />
                </div>
              </div>
              <div className="pt-5 pb-2 text-center flex flex-col grow justify-between">
                <Link to={product.link}>
                  <h3 className="font-default text-xl font-bold text-foreground mb-2 line-clamp-1 tracking-tight">
                    {product.title}
                  </h3>
                </Link>
                <p className="font-default text-base font-bold text-foreground">
                  ${product.price?.toFixed(2) || "0.00"}
                </p>
              </div>
            </div>
          </CarouselItem>)}
      </CarouselContent>
      <div className="flex items-center justify-center gap-4 mt-10">
        <CarouselPrevious className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground rounded-md shadow-sm" />
        <CarouselNext className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground rounded-md shadow-sm" />
      </div>
    </Carousel>;
}
export default function FloresDestacadas() {
  return <section data-section-id="222627" id="best-selling-sustainable-solutions" className="bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tighter">
            Best-Selling Sustainable Solutions
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg">
            Explore our most popular eco-conscious packaging, trusted by leading 
            restaurants and retailers for durability and environmental impact.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 8,
        orderby: "popularity"
      }}>
          <ProductsCarouselConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}